module.exports = __webpack_public_path__ + "static/media/oneila.1279ff9a.png";